<template>
  <div>
    <NavBar />
    <div class="about">
      <div class="card-container">
        <div class="card-body">
          <!-- Banner Section -->
          <div class="banner_holder">
            <div class="banner-home">
              <div class="banner-info">
                <h1 data-aos="fade-left">
                  Transforming <br />
                  Tomorrow, Today
                </h1>
                <p data-aos="fade-left">
                  Empowering businesses and institutions with cutting-edge
                  software
                  <br />
                  solutions, crafted precisely for your unique challenges.
                </p>
              </div>
              <div class="banner_btns">
                <button type="button" class="btn_contact">Contact Us</button>
                <button type="button" class="btn_explore">Explore</button>
              </div>
              <div class="banner_right1" data-aos="fade-right">
                <img src="@/assets/home/react.svg" alt="" />
              </div>
              <div class="banner_right2" data-aos="fade-right">
                <img src="@/assets/home/js.svg" alt="" />
              </div>
              <div class="banner_right3" data-aos="fade-right">
                <img src="@/assets/home/vue.svg" alt="" />
              </div>
              <div class="banner_right4" data-aos="fade-right">
                <img src="@/assets/home/flutter.svg" alt="" />
              </div>
              <div class="banner_right5" data-aos="fade-left">
                <img src="@/assets/home/laravel.svg" alt="" />
              </div>
              <div class="banner_right6" data-aos="fade-left">
                <img src="@/assets/home/c_shap.svg" alt="" />
              </div>
              <div class="banner_right7" data-aos="fade-left">
                <img src="@/assets/home/node.svg" alt="" />
              </div>
              <div class="banner_right8" data-aos="fade-left">
                <img src="@/assets/home/html.svg" alt="" />
              </div>
              <div class="banner_right9" data-aos="fade-left">
                <img src="@/assets/home/ts.svg" alt="" />
              </div>
            </div>
          </div>

          <!-- Line Divider -->
          <div class="linner">
            <hr />
          </div>

          <!-- Our Best Project Section -->
          <div class="banking-services">
            <div class="bast-project">
              <div class="see-title" data-aos="fade-left">
                <h2 data-aos="fade-left">Our Best Project</h2>
                <a href=""
                  ><img src="@/assets/home/icon_enter.svg" alt="" data-aos="fade-left"/>View All
                  Services</a
                >
              </div>
            </div>

            <!-- Services Section -->
            <div class="services">
              <div class="service" data-aos="fade-left">
                <div class="service-content">
                  <div class="icon">
                    <img
                      src="../assets/home/icon-1.svg"
                      alt="Mobile Banking Icon"
                    />
                  </div>
                  <h3>Delivery Management System</h3>
                  <p>
                    is a software tool that streamlines the delivery process by
                    managing orders, optimizing routes, and providing real-time
                    tracking.
                  </p>
                  <a href=""
                    ><img src="../assets/home/Frame 13.svg" alt=""
                  /></a>
                </div>
              </div>
              <div class="service" data-aos="fade-right">
                <div class="service-content">
                  <div class="icon">
                    <img
                      src="../assets/home/icon-2.svg"
                      alt="Saving Account Icon"
                    />
                  </div>
                  <h3>HR Management System</h3>
                  <p>
                    is a software solution that automates and streamlines
                    various human resource functions. It helps manage employee
                    data, recruitment, payroll, performance evaluations, and
                    benefits administration.
                  </p>
                  <a href=""
                    ><img src="../assets/home/Frame 13.svg" alt=""
                  /></a>
                </div>
              </div>
              <div class="service" data-aos="fade-right">
                <div class="service-content">
                  <div class="icon">
                    <img src="../assets/home/icon-3.svg" alt="Deposit Icon" />
                  </div>
                  <h3>Loan Management System</h3>
                  <p>
                    is a software solution designed to manage the lifecycle of
                    loans from origination to repayment. It automates processes
                    such as application processing, credit assessment,
                    disbursement, and collections.
                  </p>
                  <a href=""
                    ><img src="../assets/home/Frame 13.svg" alt=""
                  /></a>
                </div>
              </div>
              <div class="service" data-aos="fade-left">
                <div class="service-content">
                  <div class="icon">
                    <img
                      src="../assets/home/icon-4.svg"
                      alt="Business Loans Icon"
                    />
                  </div>
                  <h3>School Management System</h3>
                  <p>
                    is a software solution designed to manage the school,
                    teachers, students, total fee that students will pay for
                    school.
                  </p>
                  <a href=""
                    ><img src="../assets/home/Frame 13.svg" alt=""
                  /></a>
                </div>
              </div>
            </div>
          </div>

          <!-- Section Container -->
          <div class="section-container" data-aos="fade-left">
            <h1 class="section-title" data-aos="fade-right">
              We enable our clients to accomplish and enjoy the value of
              operational excellence using our innovative data-driven
              technological solutions.
            </h1>
            <div class="row">
              <div class="col-md-4 feature" data-aos="fade-right">
                <img src="../assets/home/Group 3.svg" alt="Download App" />
                <h3 class="feature-title">Security System</h3>
                <p class="feature-description">
                  With increasing digitization, come the risk of data and
                  digital trust. Our system solutions have passed rigorous tests
                  by the security team at our bank partners. Our dynamic
                  Research & Development team is also progressively exploring
                  and updating the security measures in our coding as well as
                  infrastructure configuration.
                </p>
              </div>

              <!-- Second Feature -->
              <div class="col-md-4 feature" data-aos="fade-top">
                <img
                  src="../assets/home/Group 3 (1).svg"
                  alt="Create Your Account"
                />
                <h3 class="feature-title">Leveraging Technologies</h3>
                <p class="feature-description">
                  With our diversified skills and experiences in both
                  open-source and proprietary technologies such as WebAssembly,
                  C++, C#, PHP, Java, Python, and modern database technologies,
                  we develop our solutions by combining the best capabilities of
                  several computer languages for optimal efficiency and
                  performance.
                </p>
              </div>

              <!-- Third Feature -->
              <div class="col-md-4 feature" data-aos="fade-left">
                <img src="../assets/home/Group 3 (2).svg" alt="Start Banking" />
                <h3 class="feature-title">Data Collection & Analysis</h3>
                <p class="feature-description">
                  Given our team’s professional backgrounds, data science
                  techniques are our core competency and we are poised to offer
                  heavy data-oriented business solutions and services.
                </p>
              </div>
            </div>
          </div>

          <!-- Lasted News and Footer -->
          <LastedNews />
          <FooTer />
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import FooTer from "@/components/FooTer.vue";
import LastedNews from "@/components/home-page/LastedNews.vue";

export default {
  name: "HomeView",
  components: {
    NavBar,
    FooTer,
    LastedNews,
  },
};
</script>

<style scoped>
/* Global Styles */
body {
  margin: 0;
  font-family: Arial, sans-serif;
}

.about {
  width: 100%;
  overflow: hidden;
}

.card-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8f7f5;
}

/* Banner Styles */
.banner-home {
  display: flex;
  position: relative;
  flex-direction: column;
  background-image: url("@/assets/home/banner.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  justify-self: center;
  height: 80vh;
  width: 90%;
  border-radius: 20px;
  color: white;
  padding: 30px;
  margin-top: 100px;
 
}
.banner_right1,
.banner_right2,
.banner_right3,
.banner_right4,
.banner_right5,
.banner_right6,
.banner_right7,
.banner_right8,
.banner_right9 {
  display: flex;
  gap: 2rem;
  position: absolute;
}
.banner_right1 {
  background-color: #042757;
  bottom: 0;
  right: 10%;
  bottom: 20%;
}
.banner_right2 {
  background-color: #fffde2;
  bottom: 0;
  right: 8%;
  bottom: 33%;
}
.banner_right3 {
  bottom: 0;
  right: 12%;
  bottom: 45%;
  background-color: #0f58a8;
  border-radius: 10px;
}
.banner_right4 {
  background-color: rgb(252, 211, 64);
  bottom: 0;
  right: 35%;
  bottom: 20%;
}
.banner_right5 {
  bottom: 0;
  right: 37%;
  bottom: 33%;
  background-color: #0f58a8;
  border-radius: 10px;
}
.banner_right6 {
  background-color: #3a3d6f;
  bottom: 0;
  right: 34%;
  bottom: 45%;
}
.banner_right7 {
  background-color: rgb(255, 255, 255);
  bottom: 0;
  right: 14%;
  bottom: 8%;
}
.banner_right8 {
  background-color: #ed7827;
  bottom: 0;
  right: 22%;
  bottom: 3%;
}
.banner_right9 {
  bottom: 0;
  right: 30%;
  bottom: 8%;
}
.banner_right1,
.banner_right2,
.banner_right3,
.banner_right4,
.banner_right5,
.banner_right6,
.banner_right7,
.banner_right8,
.banner_right9 {
  width: 60px;
  height: 60px;
  border-radius: 10px;
}
.banner_right1 img,
.banner_right2 img,
.banner_right3 img,
.banner_right4 img,
.banner_right5 img,
.banner_right6 img,
.banner_right7 img,
.banner_right8 img,
.banner_right9 img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.banner-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 5%;
  margin-bottom: 40px;
  margin-top: 90px;
}

.banner-info h1 {
  font-size: 4vw;
}

.banner-info p {
  margin-top: 20px;
  font-size: 1.5vw;
}

.banner_btns {
  display: flex;
  gap: 1rem;
  margin-left: 5%;
}

.btn_contact,
.btn_explore {
  border-radius: 32px;
  padding: 10px;
  background-color: #0f58a8;
  border: none;
  color: white;
  font-size: 1.5vw;
  width: 200px;
  cursor: pointer;
}

.btn_explore {
  background-color: transparent;
  border: 1px solid #0f58a8;
}

.btn_contact:hover,
.btn_explore:hover {
  background-color: #0b243b;
}
.btn_contact:focus,
.btn_explore:focus {
  outline: none;
  box-shadow: 0 0 5px 0 rgba(239, 239, 239, 0.636);
}
/* Divider Line */
.linner {
  margin: 40px 60px;
}

/* Services Section */
.banking-services {
  display: flex;
  width: 90%;
  margin: 5%;
  justify-content: space-between;
}

.bast-project {
  margin-bottom: 40px;
}

.bast-project h2 {
  font-size: 3vw;
}
.see-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2rem;
}

.see-title h2,
.service-content h3 {
  color: #0f58a8;
}
.service-content p {
  height: 110px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
}
.service-content a {
  display: flex;
  width: 50px;
  height: 40px;
}
.service-content a img {
  width: 100%;
  height: 40px;
}
.see-title a {
  align-items: center;
  gap: 1rem;
}
.see-title a img {
  width: 40px;
  height: 40px;
}
.services {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  width: 100%;
  justify-content: space-between;
}

.service {
  border-radius: 8px;
  padding: 20px;
  flex: 1 1 calc(40% - 10px);
  box-sizing: border-box;
}

.icon img {
  margin-bottom: 15px;
  width: 50px;
  height: 50px;
}

.service h3 {
  font-size: 1.3vw;
  margin-bottom: 15px;
}

.service p {
  font-size: 1.2vw;
}

/* Section Container */
.section-container {
  text-align: center;
  padding: 40px;
  background: linear-gradient(180deg, #000101 -37.99%, #0f58a8 129.58%);
  color: white;
  border-radius: 32px;
  margin: 0% 5%;
}

.section-title {
  font-size: 2.5vw;
  margin-bottom: 50px;
}

.row {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.feature {
  text-align: center;
  flex: 1;
}

.feature img {
  width: 100px;
  height: auto;
  margin-bottom: 20px;
}

.feature-title {
  font-size: 2vw;
  margin-bottom: 15px;
}

.feature-description {
  font-size: 1.2vw;
}


@media (min-width: 768px) and (max-width: 1024px) {
  .banner-home {
    height: 30vh;
    width: 95%;
    margin-left: 20px;
    margin-top: 70px;
  }
  .banner_right1,
  .banner_right2,
  .banner_right3,
  .banner_right4,
  .banner_right5,
  .banner_right6,
  .banner_right7,
  .banner_right8,
  .banner_right9 {
    width: 30px;
    height: 30px;
    border-radius: 5px;
    border: 1px solid rgb(17, 81, 145);
  }
  .banner_right1 img,
  .banner_right2 img,
  .banner_right3 img,
  .banner_right4 img,
  .banner_right5 img,
  .banner_right6 img,
  .banner_right7 img,
  .banner_right8 img,
  .banner_right9 img {
    width: 28px;
    height: 28px;
    border-radius: 5px;
  }
  .banner-info h1 {
    margin-top: -90px;
    font-size: 24px;
  }
  .section-container {
    display: flex;
    flex-direction: column;
    width: 95%;
    text-align: center;
    padding: 40px;
    background: linear-gradient(180deg, #000101 -37.99%, #0f58a8 129.58%);
    color: white;
    border-radius: 32px;
    margin-left: 20px;
  }
  .icon img {
    width: 40px;
    height: auto;
    margin-bottom: 10px;
  }
  .section-title {
    margin-top: 0px;
    font-size: 24px;
  }
  .banner-info p {
    font-size: 14px;
    width: 50%;
    margin-top: 0px;
  }
  .btn_contact,
  .btn_explore {
    width: 20%;
    margin-top: -30px;
  }

  .banking-services {
    display: flex;
    flex-direction: column;
    width: 95%;
    margin-left: 20px;
    justify-content: space-between;
  }
  .see-title a img {
    width: 5%;
    height: auto;
  }
  .feature-title {
    margin-left: 35px;
    font-size: 18px;
    margin-bottom: 10px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
    height: 50px;
    text-align: left;
  }
  .feature-description {
    display: flex;
    font-size: 14px;
    margin-left: 35px;
    height: 100px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
    margin-top: 0px;
    text-align: left;
    width: 90%;
  }
  .service-content {
    font-size: 14px;
    margin-left: 35px;
    height: 240px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
    margin-top: 0px;
    text-align: left;
    width: 90%;
  }
  .service-content h3 {
    font-size: 18px;
    height: 25px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
  }
  .service-content p {
    height: 100px;
    font-size: 15px;
  }
}

@media (max-width: 767px) and (min-width: 428px) {
  .banner-holder {
    height: auto; 
    min-height: 100%; 
  }
  .banner-home {
    display: flex;
    height: 50vh;
    width: 100%;
    padding: 0px;
    margin: 0px;
    margin-bottom:0px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-position: center; 
    border-radius: 0px; 
    background-attachment: fixed;
  }

  .banner_right {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 20px;
  }

  .banner_right img {
    width: 50px;
    height: 50px;
    margin: 5px;
  }
  .banner_right1,
  .banner_right2,
  .banner_right3,
  .banner_right4,
  .banner_right5,
  .banner_right6,
  .banner_right7,
  .banner_right8,
  .banner_right9 {
    display: none;
  }

  .banner-info { 
    text-align: center;
    margin-bottom: 20px; 
    
  }

  .banner-info h1 {
    font-size: 2em; 
    margin-bottom: 10px;
  }

  .banner-info p {
    font-size: 1em; 
    width: 80%; 
    margin: 0 auto; 
    height: auto; 
    overflow: hidden; 
  }

  .banner_btns {
    display: flex;
    flex-direction: none;
    align-items: center;
    margin-top: 0px;
    width: 70%;
    gap: 10px;
  }

  .btn_contact,
  .btn_explore {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%; 
    margin-bottom: 10px;
    padding: 10px; 
    font-size: 1em;
  }

  .banking-services {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 20px 0;
    align-items: center;
  }

  .bast-project {
    width: 100%; 
    text-align: center; 
    margin-bottom: 20px;
  }

  .see-title {
    display: flex;
    flex-direction: column; 
    align-items: center;
    width: 100%;
    gap: 10px;
  }

  .see-title h2 {
    font-size: 1.2em;
    margin-bottom: 0;
  }

  .see-title a {
    font-size: 1em;
  }

  .see-title a img {
    width: 20px; 
    height: auto;
  }

  .services {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center; 
    gap: 20px; 
  }

  .service {
    display: flex;
    flex-direction: column; 
    width: 90%;
    background-color: white;
    padding: 20px; 
    border-radius: 8px; 
    box-sizing: border-box; 
  }
    .icon {
        display: flex;
        justify-content: center;
    }
  .icon img {
    width: 50px;
    height: auto;
    margin-bottom: 10px;
  }

  .service-content h3 {
    font-size: 1.2em;
    margin-bottom: 10px;
  }

  .service-content p {
    font-size: 1em;
    height: auto; 
    overflow: hidden;
  }

  .service-content a img {
    width: 30px;
    height: auto;
  }

  .section-container {
    padding: 20px;
    margin: 20px 5%; 
  }

  .section-title {
    font-size: 1.5em;
    margin-bottom: 20px;
  }

  .row {
    flex-direction: column;
    gap: 20px; 
  }

  .feature {
    width: 90%;
    margin-bottom: 20px;
    text-align: center;
  }

  .feature img {
    width: 60px;
    height: auto;
    margin-bottom: 10px;
  }

  .feature-title {
    font-size: 1.2em;
    margin-bottom: 10px;
  }

  .feature-description {
    font-size: 1em;
    height: auto; 
    overflow: hidden;
  }
}
</style>
